import { configureStore, combineReducers } from '@reduxjs/toolkit'
import adminSlice from './reducer/admin-reducer'
import clientSlice from './reducer/client-reducer'

export const store = configureStore({
  reducer: combineReducers({
    adminContents: adminSlice,
    clientContents: clientSlice,
  }),
})

declare global {
  type RootState = ReturnType<typeof store.getState>
  type AppDispatch = typeof store.dispatch
}
